import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutType } from '../../../core/configs/config';
import { LayoutService } from '../../../core/layout.service';
import { CommonModule } from '@angular/common';
import { KeeniconComponent } from '../../../../../keenicon/keenicon.component';

@Component({
	selector: 'app-sidebar-logo',
	templateUrl: './sidebar-logo.component.html',
	styleUrls: ['./sidebar-logo.component.scss'],
	imports: [CommonModule],
	standalone: true,
})
export class SidebarLogoComponent implements OnInit, OnDestroy {
	private unsubscribe: Subscription[] = [];
	private layout = inject(LayoutService);

	@Input() toggleButtonClass = '';
	@Input() toggleEnabled = true;
	@Input() toggleType = '';
	@Input() toggleState = '';
	currentLayoutType: LayoutType | null = null;

	toggleAttr = '';

	constructor() {
		this.layout = inject(LayoutService);
	}

	ngOnInit(): void {
		this.toggleAttr = `app-sidebar-${this.toggleType}`;
		const layoutSubscr = this.layout.currentLayoutTypeSubject.asObservable().subscribe((layout) => {
			this.currentLayoutType = layout;
		});
		this.unsubscribe.push(layoutSubscr);
	}

	ngOnDestroy() {
		this.unsubscribe.forEach((sb) => sb.unsubscribe());
	}
}
